<template>
  <PageContainer>
    <SectionContainer class="pt-2">
      <h1>Schedule</h1>
      <div class="flex flex-row justify-center">
        <img src="https://withjoy.com/media/ea2d0ea6d5be9f535f403cfdb5e3515862d4085be61d8939e/NPiBaXTT9uuWA3xDHWQi_IMG_2734.jpg?rendition=medium" class="my-16 max-w-md">
      </div>
      <h2>Thursday, 26 February 2026</h2>
      <h2 class="-mt-2 font-normal">Tagaytay, Philippines</h2>
      <div class="w-full mx-auto max-w-md text-left">
        <h3 class="ml-6 mt-12">Ceremony</h3>
        <a href="https://maps.app.goo.gl/3dRpuJiuKQ8EsR6q8">
          <p class="ml-6">📍 <span class="underline">St. Benedict Parish</span></p>
        </a>
        <div class="mx-6">
          <iframe title="Map for St. Benedict Parish, South Boulevard, Silang, Cavite, Philippines" width="" height="320px" loading="lazy" src="https://www.google.com/maps/embed/v1/place?key=AIzaSyD6TNGL9KLlNOLYOxr04gHM5gbmt1SXd2Q&q=place_id:ChIJV3W5lAV9vTMRW7EJ9jsCsZg&zoom=10" class="w-full my-4 rounded-lg"></iframe>
          <p>Everyone is expected to arrive before 10:00AM. Guests arriving late will not be allowed to enter the church.</p>
        </div>
        <ol class="relative border-s border-theme-navy mt-8 ml-12">                  
          <li class="flex gap-2 ml-6 mb-4 ms-4">
            <div class="absolute w-3 h-3 bg-theme-navy rounded-full mt-1.5 -start-1.5 border border-white"></div>
            <p class="w-1/3">9:30 AM</p>
            <p class="w-2/3">Guest Arrival</p>
          </li>
          <li class="flex gap-2 ml-6 mb-4 ms-4">
            <div class="absolute w-3 h-3 bg-theme-navy rounded-full mt-1.5 -start-1.5 border border-white"></div>
            <p class="w-1/3">10:00 AM</p>
            <p class="w-2/3">Ceremony</p>
          </li>
        </ol>
        <div class="mx-6">
          <h3 class="mt-12">Break</h3>
          <p>There's a gap between the ceremony and reception, so guests are encouraged to organise their own lunch. Let us know if you need help with this!</p>
        </div>
        <h3 class="ml-6 mt-12">Reception</h3>
        <a href="https://maps.app.goo.gl/7sJ6gxc7YQLyFPTE8">
          <p class="ml-6">📍 <span class="underline">Aquila Crystal Palace</span></p>
        </a>
        <div class="mx-6">
          <iframe title="Map for Aquila Crystal Palace Tagaytay, Tagaytay, Cavite, Philippines" width="" height="320px" loading="lazy" src="https://www.google.com/maps/embed/v1/place?key=AIzaSyD6TNGL9KLlNOLYOxr04gHM5gbmt1SXd2Q&q=place_id:ChIJOfyGcNx5vTMRuzCliwxp2VY&zoom=10" class="w-full my-4 rounded-lg"></iframe>
          <p>Arrive early to enjoy photos, snacks and drinks. The program for the reception will start at 5:30PM.</p>
        </div>
        <ol class="relative border-s border-theme-navy mt-8 ml-12">                  
          <li class="flex gap-2 ml-6 mb-4 ms-4">
            <div class="absolute w-3 h-3 bg-theme-navy rounded-full mt-1.5 -start-1.5 border border-white"></div>
            <p class="w-1/3">4:00 PM</p>
            <p class="w-2/3">Guest Arrival</p>
          </li>
          <li class="flex gap-2 ml-6 mb-4 ms-4">
            <div class="absolute w-3 h-3 bg-theme-navy rounded-full mt-1.5 -start-1.5 border border-white"></div>
            <p class="w-1/3">4:30 PM</p>
            <p class="w-2/3">Photos</p>
          </li>
          <li class="flex gap-2 ml-6 mb-4 ms-4">
            <div class="absolute w-3 h-3 bg-theme-navy rounded-full mt-1.5 -start-1.5 border border-white"></div>
            <p class="w-1/3">5:30 PM</p>
            <p class="w-2/3">Reception</p>
          </li>
          <li class="flex gap-2 ml-6 mb-4 ms-4">
            <div class="absolute w-3 h-3 bg-theme-navy rounded-full mt-1.5 -start-1.5 border border-white"></div>
            <p class="w-1/3">6:30 PM</p>
            <p class="w-2/3">Dinner</p>
          </li>
          <li class="flex gap-2 ml-6 mb-4 ms-4">
            <div class="absolute w-3 h-3 bg-theme-navy rounded-full mt-1.5 -start-1.5 border border-white"></div>
            <p class="w-1/3">8:00 PM</p>
            <p class="w-2/3">Party</p>
          </li>
          <li class="flex gap-2 ml-6 mb-4 ms-4">
            <div class="absolute w-3 h-3 bg-theme-navy rounded-full mt-1.5 -start-1.5 border border-white"></div>
            <p class="w-1/3">10:00 PM</p>
            <p class="w-2/3">After Party</p>
          </li>
        </ol>
      </div>
    </SectionContainer>
  </PageContainer>
</template>

<script>
import PageContainer from '@/pages/PageContainer'
import SectionContainer from '@/pages/SectionContainer'

export default {
  name: 'SchedulePage',
  components: {
    PageContainer,
    SectionContainer,
  },
  data() {
    return {
    }
  },
  beforeMount() {
  },
  methods: {
  },
}
</script>